import { createContext, useContext } from "react";

export const AuthContext = createContext({
  isAuthenticated: false,
  isAdminUser: false,
  isLicenseManager: false,
  isLicenseManagerAdmin: false,
  emailAddress: "",
  userHasAuthenticated: () => {},
  emailAddressHandler: () => {}
});

export const useAuth = () => useContext(AuthContext);
